import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kiacarenceonrentforcorporateinpune() {



  const cardData =
  {
    keyword: ' Kia Carens On Rent for Corporate in Pune',
    heading: 'Pune Corporate Cars India Private Limited: Kia Carens On Rent for Corporate in Pune',
    headingDescription: 'Pune Corporate Cars India Private Limited offers premium Kia Carens on rent for corporate in Pune, delivering spacious, comfortable, and stylish travel solutions for employees, managers, clients, and senior executives. The Kia Carens provides superior cabin space, smooth ride quality, and modern amenities, making it ideal for daily office commute, airport transfers, business meetings, corporate events, and industrial visits. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, we ensure punctual, safe, and hassle-free mobility. Pune Corporate Cars India Private Limited guarantees a reliable and premium corporate travel experience with Kia Carens rentals across Pune.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

 "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],


"services": [
{
"name": "Kia Carens Rental Pune",
"description": "Kia Carens Rental Pune provides premium MPV vehicles for corporate, office, and personal travel. The service ensures comfortable seating, trained drivers, GPS tracking, and timely pickups for daily commutes, business trips, and intercity travel, offering companies a reliable and efficient transportation solution."
},
{
"name": "Corporate Carens MPV Pune",
"description": "Corporate Carens MPV Pune offers dedicated Kia Carens vehicles for corporate employee transportation. With structured routes, multi-shift support, GPS-enabled vehicles, and professional drivers, the service ensures safe, punctual, and comfortable commutes for staff, IT park employees, and office teams across Pune."
},
{
"name": "Carens Employee Shuttle Pune",
"description": "Carens Employee Shuttle Pune delivers reliable shuttle services using Kia Carens MPVs for corporate employees. The service focuses on optimized routing, safe travel, trained drivers, and multi-passenger capacity, making it ideal for daily office commutes and IT park staff transportation."
},
{
"name": "Business Carens Hire Pune",
"description": "Business Carens Hire Pune provides professional Kia Carens vehicles for corporate travel, client meetings, and business trips. The service ensures comfortable seating, trained drivers, GPS tracking, and timely service, making it a preferred choice for executives and teams requiring safe and reliable transportation."
},
{
"name": "Carens Airport Cab Pune",
"description": "Carens Airport Cab Pune offers safe and punctual airport transfers using Kia Carens MPVs. The service includes luggage assistance, trained chauffeurs, and GPS-monitored vehicles, ensuring a stress-free and comfortable travel experience for corporate staff, executives, and VIP clients."
},
{
"name": "Carens Outstation Rental Pune",
"description": "Carens Outstation Rental Pune provides long-distance travel solutions with Kia Carens MPVs for corporate trips, client visits, and intercity travel. The service features professional drivers, GPS-enabled vehicles, comfortable seating, and optimized routes to ensure safe and hassle-free journeys."
},
{
"name": "Best Carens Corporate Cab Pune",
"description": "Best Carens Corporate Cab Pune offers premium Kia Carens MPVs for corporate employee transport and executive travel. The service ensures safety, punctuality, GPS tracking, trained chauffeurs, and well-maintained vehicles for seamless office commutes, business trips, and client visits."
},
{
"name": "Affordable Carens Hire Pune",
"description": "Affordable Carens Hire Pune delivers budget-friendly Kia Carens MPV rentals for corporate staff, office employees, and group travel. The service provides reliable, safe, and comfortable transportation with professional drivers, structured routes, and punctual pickups at competitive rates."
},
{
"name": "Carens Monthly Hire Pune",
"description": "Carens Monthly Hire Pune provides long-term Kia Carens MPV rental solutions for companies requiring consistent employee transport. The service includes fixed monthly plans, trained drivers, GPS-monitored vehicles, and structured commuting schedules for safe and efficient daily travel."
},
{
"name": "Carens Office Commute Pune",
"description": "Carens Office Commute Pune specializes in daily commuting services for office employees using Kia Carens MPVs. The service includes optimized routes, punctual pickups, trained drivers, and comfortable seating, ensuring stress-free and reliable transportation for corporate staff."
},
{
"name": "Kia Carens Fleet Provider Pune",
"description": "Kia Carens Fleet Provider Pune delivers a fully managed fleet of Kia Carens MPVs for corporate employee transportation. The service includes driver management, maintenance, GPS tracking, and route optimization to ensure safe, efficient, and seamless daily commuting for businesses and organizations."
},
{
"name": "Corporate MPV Rental Pune",
"description": "Corporate MPV Rental Pune offers multi-passenger Kia Carens vehicles for corporate and office travel needs. The service provides structured routes, professional drivers, GPS-enabled vehicles, and comfortable seating, ensuring reliable and convenient employee transport across Pune."
},
{
"name": "Staff Transport Carens Pune",
"description": "Staff Transport Carens Pune provides safe and efficient MPV transport for office, IT, and industrial staff. The service includes trained drivers, GPS tracking, punctual pickups, and multi-shift support to ensure seamless daily commuting for employees using Kia Carens vehicles."
},
{
"name": "IT Employee Carens Shuttle",
"description": "IT Employee Carens Shuttle offers dedicated Kia Carens transport for IT park employees and tech company staff. The service ensures timely pickups, structured routes, GPS-enabled vehicles, and trained chauffeurs for safe and comfortable daily commutes in Pune."
},
{
"name": "Carens Chauffeur Car Pune",
"description": "Carens Chauffeur Car Pune provides professionally driven Kia Carens MPVs for executives, VIP clients, and corporate staff. The service emphasizes comfort, safety, punctuality, and reliability for office, business, and outstation travel, offering a premium commuting experience."
}
],

"tableData": [
["Kia Carens Rental Pune", "Corporate Carens MPV Pune"],
["Carens Employee Shuttle Pune", "Business Carens Hire Pune"],
["Carens Airport Cab Pune", "Carens Outstation Rental Pune"],
["Best Carens Corporate Cab Pune", "Affordable Carens Hire Pune"],
["Carens Monthly Hire Pune", "Carens Office Commute Pune"],
["Kia Carens Fleet Provider Pune", "Corporate MPV Rental Pune"],
["Staff Transport Carens Pune", "IT Employee Carens Shuttle"],
["Carens Chauffeur Car Pune", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Kia Carens On Rent for Corporate in Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers Kia Carens rentals for corporate clients in Pune, providing comfortable and reliable transportation for business travel."
  },
  {
    "WhyChooseheading": "Spacious & Comfortable Kia Carens",
    "WhyChoosedescription": "Our Kia Carens vehicles offer ample seating, modern amenities, and a smooth ride, making them ideal for employee commuting and executive travel."
  },
  {
    "WhyChooseheading": "Ideal for Team Travel & Corporate Events",
    "WhyChoosedescription": "Whether for employee pickups, business meetings, or corporate events, Kia Carens ensures a comfortable and convenient travel experience."
  },
  {
    "WhyChooseheading": "Professional Chauffeur Service",
    "WhyChoosedescription": "All rentals come with trained and courteous drivers, ensuring safe, punctual, and disciplined travel for corporate clients."
  },
  {
    "WhyChooseheading": "Punctual & Hassle-Free Service",
    "WhyChoosedescription": "We ensure timely pickups and drops, making corporate travel efficient, smooth, and stress-free."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "We provide hourly, daily, and long-term rental options, allowing businesses to choose plans tailored to their corporate travel needs."
  },
  {
    "WhyChooseheading": "Safe & Sanitized Vehicles",
    "WhyChoosedescription": "All Kia Carens vehicles are regularly sanitized, well-maintained, and equipped with modern safety features for secure corporate travel."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination."
  }
]






























  }

const faqData = [
  {
    question: 'Do you provide Kia Carens on rent for corporate clients in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers Kia Carens rentals for corporate travel, executive transfers, and team transportation in Pune.',
  },
  {
    question: 'Why choose Kia Carens for corporate travel?',
    answer: 'Kia Carens offers spacious seating, comfort, and smooth rides, making it ideal for transporting employees and executives.',
  },
  {
    question: 'How can companies book Kia Carens for corporate use?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'Can multiple Kia Carens vehicles be booked for large corporate teams?',
    answer: 'Yes, Pune Corporate Cars India Private Limited can provide multiple vehicles to accommodate large groups for corporate travel.',
  },
  {
    question: 'Are chauffeurs provided with Kia Carens rentals?',
    answer: 'Absolutely. All Kia Carens bookings come with professional and trained chauffeurs for a safe and comfortable ride.',
  },
  {
    question: 'Do you offer flexible rental packages for Kia Carens?',
    answer: 'Yes, we provide hourly, half-day, full-day, and monthly rental options to suit corporate requirements.',
  },
  {
    question: 'Can Kia Carens be hired for VIP corporate clients?',
    answer: 'Yes, Kia Carens is a comfortable and reliable option for VIP executives and important corporate guests.',
  },
  {
    question: 'What safety measures are followed for Kia Carens rentals?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by verified and trained chauffeurs.',
  },
  {
    question: 'What payment options are available for Kia Carens corporate rentals?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aniket Shinde',
    feedback: 'Hired Kia Carens for corporate travel. Very comfortable and professional service. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ishani More',
    feedback: 'Excellent Kia Carens rental service for our Pune office. Punctual, reliable, and well-maintained vehicles.',
    rating: 5,
  },
];

























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kia Carens On Rent for Corporate in Pune",
  "image": "https://www.punecorporatecars.com/assets/images/kia-carens-corporate-pune.jpg", // replace with actual image URL
  "description": "Pune Corporate Cars India Private Limited provides Kia Carens on rent for corporate clients in Pune, including employee shuttles, office pick-up and drop, business travel, outstation trips, and airport transfers. Ideal for IT employees, corporate fleets, and monthly commute requirements with comfort and reliability.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  // update if needed
    "ratingCount": "5500", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2100", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/kia-carens-rent-corporate-pune"
  }
};





  return (
    <div>
<Helmet>
  <title>Kia Carens On Rent for Corporate in Pune | Employee & Business MPV Hire | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Pune Corporate Cars India Private Limited provides Kia Carens on rent for corporate clients in Pune, including employee shuttles, office pick-up and drop, business travel, outstation trips, and airport transfers. Ideal for IT employees, corporate fleets, and monthly commute requirements with comfort and reliability."
  />

  <meta
    name="keywords"
    content="Kia Carens Rental Pune, Corporate Carens MPV Pune, Carens Employee Shuttle Pune, Business Carens Hire Pune, Carens Airport Cab Pune, Carens Outstation Rental Pune, Best Carens Corporate Cab Pune, Affordable Carens Hire Pune, Carens Monthly Hire Pune, Carens Office Commute Pune, Kia Carens Fleet Provider Pune, Corporate MPV Rental Pune, Staff Transport Carens Pune, IT Employee Carens Shuttle, Carens Chauffeur Car Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/39.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kiacarenceonrentforcorporateinpune;